export default __webpack_public_path__ + "static/media/badge.dc4630bc.jpg";